import { render } from "./App.vue?vue&type=template&id=c581ab52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c581ab52&lang=css"
script.render = render

export default script